import { WrapperLoading, Spinner } from '@/app/App.styles';

export function PageLoading() {
  return (
    <WrapperLoading $loading={true} data-testid="page-loading">
      <Spinner $loading={true} />
    </WrapperLoading>
  );
}
